import React from "react";
import { PlayCircle } from "lucide-react";
import { useReveal } from "./landingUtils";

export const VIDEO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_drug-stock-study/artifacts/08a4837c6c5805ab_Farmaniza%20Extended%281%29.mp4";

export function VideoDemo() {
  const [ref, cls] = useReveal();
  return (
    <section id="video" className="py-20 sm:py-28 bg-slate-50 scroll-mt-16" data-testid="landing-video">
      <div ref={ref} className={"max-w-6xl mx-auto px-5 sm:px-8 " + cls}>
        <div className="max-w-2xl">
          <div className="font-mono text-xs font-semibold uppercase tracking-widest text-[#1f6fd1] flex items-center gap-1.5"><PlayCircle size={14} /> Vídeo</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mt-3 leading-tight text-slate-900">Mira Farmanaliza en acción</h2>
          <p className="text-slate-600 mt-4 text-base md:text-lg">En pocos minutos verás cómo detectar tu stock parado, comparar tus ventas y motivar a tu equipo con datos reales.</p>
        </div>
        <div className="mt-10 rounded-3xl overflow-hidden shadow-2xl ring-1 ring-slate-200 bg-black">
          <video className="w-full h-auto block" controls playsInline preload="metadata" src={`${VIDEO_URL}#t=0.5`} data-testid="landing-video-player">
            Tu navegador no puede reproducir este vídeo.
          </video>
        </div>
      </div>
    </section>
  );
}
